import {Component} from '@angular/core';
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {AceLoggerService} from "@logging/ace-logger.service";
import {AceLogger} from "@logging/ace-logger";
import {I18nMessage} from "@shared/api/model/i18n";

export interface ProgressModalOptions {
  stripped?: boolean;
  progressPending?: boolean;
  allowCancel?: boolean;
  loadingText?: I18nMessage;
  cancelText?: I18nMessage;
  modalSize?: 'sm' | 'md' | 'lg' | 'xl' | string;
  cancelFn?: (reason?: any) => void;
}

@Component({
  selector: 'app-ace-progress-bar',
  templateUrl: './ace-progress-bar.component.html',
  styleUrls: ['./ace-progress-bar.component.scss'],
  standalone: false
})
export class AceProgressBarComponent {
  public readonly DISMISSED_CANCEL_REASON = 'User cancel';

  private readonly logger: AceLogger;
  private progressPercentage: number;

  stripped: boolean;
  progressPending: boolean;
  allowCancel: boolean;
  loadingText: I18nMessage;
  cancelText: I18nMessage;

  constructor(public activeModal: NgbActiveModal,
              private logService: AceLoggerService) {
    this.logger = this.logService.create(AceProgressBarComponent.name);
  }

  static createModal(modalService: NgbModal, modalOptions: ProgressModalOptions = {}) {
    const modalRef = modalService.open(AceProgressBarComponent, {
      size: modalOptions.modalSize || 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
    const modalInstance: AceProgressBarComponent = modalRef.componentInstance;
    modalInstance.progressPending = modalOptions.progressPending ?? true;
    modalInstance.progressPercentage = modalInstance.progressPending ? 100 : 0;
    modalInstance.stripped = modalOptions.stripped ?? false;
    modalInstance.loadingText = modalOptions.loadingText ?? {messageKey: 'Loading...'};
    modalInstance.allowCancel = modalOptions.allowCancel ?? false;
    modalInstance.cancelText = modalOptions.cancelText ?? {messageKey: 'Cancel'};
    modalRef.result.then(() => {
    }, (dismissed) => {
      if (modalOptions.cancelFn) {
        modalOptions.cancelFn(dismissed);
      }
    });
    return modalRef;
  }

  setProgressPercent(percent: number): void {
    if (percent >= 0 && percent <= 100) {
      this.progressPercentage = percent;
      if (this.progressPending) {
        this.progressPending = false;
      }
    } else {
      throw new Error('Invalid percent value passed to setProgressPercent: ' + percent);
    }
  }

  get getProgressPercent(): number {
    return this.progressPercentage;
  }

  onCancel() {
    this.activeModal.dismiss(this.DISMISSED_CANCEL_REASON);
  }
}
